// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"430bceb6","727":"c7c4ae92","857":"62a310a2"}[chunkId] + ".chunk.js";
};